import { render, staticRenderFns } from "./ep_table_column.vue?vue&type=template&id=d4f524ae&scoped=true"
import script from "./ep_table_column.vue?vue&type=script&lang=js"
export * from "./ep_table_column.vue?vue&type=script&lang=js"
import style0 from "./ep_table_column.vue?vue&type=style&index=0&id=d4f524ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f524ae",
  null
  
)

export default component.exports